import React, { PropsWithChildren } from 'react';

import { H1 } from './elements';

export const Title: React.FC<PropsWithChildren<{ className?: string }>> = ({
  children,
  ...restProps
}) => {
  return <H1 {...restProps}>{children}</H1>;
};
